import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';

@Component({
  selector: 'rt-candidate-rating',
  templateUrl: './candidate-rating.component.html',
  styleUrls: ['./candidate-rating.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateRatingComponent implements OnChanges {
  @Input() public rating: number;

  public hasRating: boolean = false;
  public iconName: IconName = 'star-border';
  public roundedRating: string = '-';

  public ngOnChanges(changes: SimpleChanges): void {
    const { rating } = changes;

    if (rating) {
      this.hasRating = Boolean(this.rating && this.rating > 0);
      this.iconName = this.hasRating ? 'star' : 'star-border';
      this.roundedRating = this.hasRating ? this.rating.toFixed(1) : '-';
    }
  }
}
